const oneMinLotSizeCases = ["CLP.SQM", "CLP.ENIC", "CLP.CCU", "CLP.BSAC", "CLP.BCH"]
const microLotCases = ["BTCUSD"]
const lotSizeExcludeIndexCases = ["VIX_", "Bvspa_"]

export { oneMinLotSizeCases, microLotCases, lotSizeExcludeIndexCases }
